export const PLAT_PLUS_ENDORSEMENT = '0112';
export const PLAT_ENDORSEMENT = '0049';
export const GOLD_ENDORSEMENT = '0040';
